import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSubCategoryProducts } from './SubCategoryProductSlice';
import { deleteProduct, changeActiveStatus } from '../Product/productSlice';
import { Container, Modal, Toast, Button } from "react-bootstrap";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import CommonButton from "../../components/commonButton";
import CommonPagination from "../../components/commonPagination";
import CommonTable from '../../components/commonTable';
import { Add01Icon } from "../../assets/icons";
import { useLoader } from "../../context/LoaderContext";

const SubCategoryProductList = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const { subCategoryProducts } = useSelector((state) => state.subCategoryProducts);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProductId, setSelectedProductId] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const limit = 10;
  const totalPages = Math.ceil(subCategoryProducts?.total_records / limit);
  const total = subCategoryProducts?.total_records || 0;

  const location = useLocation();
    const pathSegments = location.pathname.split("/").filter(Boolean);
    const selected_sub_category_id = pathSegments.length > 1 && pathSegments[0] === "sub-category-products"
      ? pathSegments[1] 
      : null;
  const params = new URLSearchParams(location.search);
  const initialPage = parseInt(params.get("page") || "1");
  const [currentPage, setCurrentPage] = useState(initialPage);
  const token = localStorage.getItem('auth-token');

  let productMessage = localStorage.getItem('sub_category_product_notify_message');

  useEffect(() => {
    if (productMessage) {
      setSnackbarMessage(productMessage);
      setSnackbarVariant("success");
      setShowSnackbar(true);
      localStorage.removeItem('sub_category_product_notify_message');
    }
  }, [productMessage])

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      const payload = {
        page: currentPage,
        search: searchTerm,
        limit: limit,
        sub_category_id : selected_sub_category_id,
        token
      };
  
      try {
        if (token && selected_sub_category_id) {
          await dispatch(getSubCategoryProducts({ payload }));
        }
      } catch (error) {
        setLoading(false);
        console.error("Error fetching sub category products:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchProducts();
  }, [dispatch, token, currentPage, searchTerm, setLoading, selected_sub_category_id]);
  

  const columns = [
    { label: 'Name', key: 'product_name' },
    { label: 'Category', key: 'category.category_name' },
    { label: 'Subcategory', key: 'subcategory.category_name' },
    { label: 'Price(₹)', key: 'price' },
    { label: 'Selling Price(₹)', key: 'selling_price' },
    { label: 'Quantity', key: 'quantity' },
    { label: 'Min Order Quantity', key: 'min_order_quantity' },
    // {label: 'Image', key: 'image', type: 'image' },
    { label: 'created at', key: 'created_at', type: 'date' },
    {label: 'Status', key: 'is_active', type: 'status' },
  ];

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
    navigate(`/sub-category-products?page=${newPageNumber}`);
  };

  const handleDeleteNew = async () => {
    if (selectedProductId) {
      await dispatch(deleteProduct(selectedProductId)).then((res) => {
        if(res.payload.success) {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          const payload = {
            page: currentPage,
            search: searchTerm,
            limit: limit,
            sub_category_id : selected_sub_category_id,
            token
          };
          dispatch(getSubCategoryProducts({ payload }));
        } else {
          setShowDeleteModal(false);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("danger");
          setShowSnackbar(true);
        }
      });
    }
  };

  const handleEdit = (row) => {
    // setSelectedProductId(row.id);
    navigate(`/sub-category-product-edit/${row.id}?page=${currentPage}`);
    // handleOpen();
  };

  // const handleOpen = () => {
  //   setTimeout(() => {
  //     setShowEditModal(true);
  //   }, 1000);
  // };
  

  const handleDelete = (row) => {
    setSelectedProductId(row.id);
    setShowDeleteModal(true);
  };

  const handleView = (row) => {
    setSelectedProductId(row.id);
  };

  const handleStatusChange = async (row) => {
    setSelectedProductId(row.id);
    setShowStatusModal(true);
  }

  const handleStatusChangeNew = async () => {
    await dispatch(changeActiveStatus(selectedProductId)).then((res) => {
      if(res.payload.success) {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("success");
        setShowSnackbar(true);
        const payload = {
          page: currentPage,
          search: searchTerm,
          limit: limit,
          sub_category_id : selected_sub_category_id,
          token
        };
        dispatch(getSubCategoryProducts({ payload }));
      } else {
        setShowStatusModal(false);
        setSnackbarMessage(res.payload.message);
        setSnackbarVariant("danger");
        setShowSnackbar(true);
      }
    });
  }

  const categoryStack = JSON.parse(localStorage.getItem("category_id_stack") || "[]");

  const currentCategoryId = pathSegments[1];
  const currentCategoryName = JSON.parse(localStorage.getItem("category-data") || "{}")?.category_name;

  // Only push if not already at the top of stack
  const lastStackItem = categoryStack[categoryStack.length - 1];
  if (!lastStackItem || lastStackItem.id !== currentCategoryId) {
    categoryStack.push({
      id: currentCategoryId,
      name: currentCategoryName || "Untitled",
    });
  }

  localStorage.setItem("category_id_stack", JSON.stringify(categoryStack));

    useEffect(() => {
      if (initialPage) {
        setCurrentPage(initialPage);
      }     
    }, [initialPage])

  return (
    <>
      <Container fluid className="px-0">
        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to delete this product?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDeleteNew}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={showStatusModal} onHide={() => setShowStatusModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Status Update</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change status?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowStatusModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleStatusChangeNew}>
              Change
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={3000}
          autohide
          bg={snackbarVariant}
          style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
        >
          <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
        </Toast>

        <div className="p-4 d-flex align-items-center justify-content-between gap-4">
          <Input
            type="search"
            value={searchTerm}
            placeholder="Search Product"
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setCurrentPage(1);
              navigate(`/sub-category-products?page=1`);
            }}
            className="shadow-none base-search"
          />

          <CommonButton
            icon={<Add01Icon width={16} height={16} color="#ffffff" strokeWidth="2" />}
            title="Add Product"
            className="btn-primary common-one-shadow"
            onClick={() => {
              navigate(`/sub-category-product-add/${selected_sub_category_id}?page=${currentPage}`);
            }}
          />
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow">
            <CommonTable
              columns={columns}
              data={subCategoryProducts?.data || []}
              url={subCategoryProducts?.url || []}
              showActions={true}
              actions={{
                showEdit: true,
                showDelete: true,
                showView: false,
                onEdit: handleEdit,
                onDelete: handleDelete,
                onView: handleView
              }}
              onStatusChange={handleStatusChange}
            />
        </div>

        <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
          <p className="custom-table-infotext">
            Displaying {(limit * (currentPage - 1)) + 1} to {Math.min(limit * currentPage, total)} of {total} Products
          </p>

          <div>
            {totalPages > 1 ? (
              <CommonPagination
                totalItems={total}
                itemsPerPage={limit}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            ) : null}
          </div>
        </div>
      </Container>
    </>
  );
};

export default SubCategoryProductList;
